import { useEffect, useState } from 'react';
import { DropzoneFile } from 'dropzone';
import { ImageModel } from '../types';

function getInitialIsDoneUploadingState(imageData: ImageModel[]) {
    return imageData.reduce((acc, elem) => {
        return acc && elem.thumbnails.length > 0 && elem.uploadsInProgress.length === 0;
    }, true);
}

export function isUploadFinished(data: ImageModel, numberOfFilesAdded: number): boolean {
    let { uploadsInProgress, thumbnails, failedUploads } = data;

    if (failedUploads.length > 0) {
        return false;
    }

    if (thumbnails.length < 1) {
        return false;
    }

    if (thumbnails.some((thumbnail) => thumbnail.reference === null)) {
        return false;
    }

    if (uploadsInProgress.length === 0 && numberOfFilesAdded > 0) {
        return false;
    }

    if (uploadsInProgress.length > 0) {
        return false;
    }

    return true;
}

export function useImageDataUpdate(imageData: ImageModel[], onUploadComplete: () => void) {
    let [filesAdded, setFilesAdded] = useState<DropzoneFile[]>([]);

    let initialsIsDoneUploadingState = getInitialIsDoneUploadingState(imageData);
    let [isDoneUploading, setIsDoneUploading] = useState(initialsIsDoneUploadingState);

    function addFileToDropzone(file: DropzoneFile) {
        setFilesAdded((previousFiles) => [...previousFiles, file]);
    }

    function removeFileFromDropzone(file: DropzoneFile) {
        setFilesAdded((previousFiles) => previousFiles.filter((f) => f.name !== file.name));
    }

    useEffect(() => {
        imageData.forEach((data) => {
            if (isUploadFinished(data, filesAdded.length)) {
                setIsDoneUploading(true);
                setFilesAdded([]);
                onUploadComplete();
            }
        });
    }, [imageData, onUploadComplete]);

    return {
        filesAdded,
        isDoneUploading,
        setIsDoneUploading,
        addFileToDropzone,
        removeFileFromDropzone
    };
}
